export const EXTEND_SESSION = "EXTEND_SESSION"
export const EXTEND_SESSION_SUCCESS = "EXTEND_SESSION_SUCCESS"
export const EXTEND_SESSION_ERROR = "EXTEND_SESSION_ERROR"
export const EXTEND_SESSION_CLEAN = "EXTEND_SESSION_CLEAN"
